<template>
    <svg :width="size" :height="size" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15 3V7M9 3V7M4 11H20M20 11V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V7C4 5.89543 4.89543 5 6 5H18C19.1046 5 20 5.89543 20 7V11Z"
            :stroke="color"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
<script>
export default {
    name: "CalendarIcon",
    props: {
        size: {
            type: [String, Number],
            default: 24
        },
        color: {
            type: String,
            default: "#3965FF"
        }
    }
}
</script>

<style lang="sass" scoped>
.hovered
    cursor: pointer
    transition: .2s
    &:hover
        path
            stroke: #3965FF !important
</style>
